/**
 * Directive used create the payment request and redirect to the payment page
 */
angular.module('westBerkshireEvents.paymentRedirect').directive('wbPaymentRedirect', () => {
    return {
        restrict: 'AE',
        replace: true,
        scope: false,
        controller: wbPaymentRedirectController
    };
});

function wbPaymentRedirectController($scope, $attrs, $location, AlertService, $http, $window, LoadingService, $rootScope) {

    $rootScope.connection_started.then(() => {
        // if there's nothing to pay, skip this step
        if ($scope.bb.total.due_now === 0) {

            $scope.skipThisStep();
            $scope.decideNextPage();
            return;

        } else {
            return $scope.initialise();
        }
    }, err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));

    $scope.initialise = async function () {
        const loader = LoadingService.$loader($scope);
        loader.notLoaded();

        let bookingID;

        console.log($scope.bb.total);

        // now we have to loop over all bookings to build outputs
        const bookingIDs = [];
        const revCodes = [];
        const descriptions = [];
        const amounts = [];

        if ($scope.bb.total.items[0].bookings) {
            for (const purchase of $scope.bb.total.items) {
                for (const booking of purchase.bookings) {
                    bookingIDs.push(booking.id);
                }
            }
            // bookingID = $scope.bb.total.items[0].bookings[0].id;
        } else {
            bookingID = $scope.bb.total.items[0].id;
            for (const booking of $scope.bb.total.items) {
                console.log(booking);
                const chain = await booking.$getEventChain();
                console.log(chain);
                bookingIDs.push(booking.id);
                descriptions.push(booking.full_describe);
                amounts.push(parseFloat(booking.price / 100));
                let revCode = 'WBEVCALO';
                const longRevCode = chain.extra.heycentric_rev_code;
                if (longRevCode) {
                    const revCodeParts = longRevCode.split('(');
                    if (revCodeParts.length > 0) {
                        const revCodePart = revCodeParts[revCodeParts.length - 1].split(')');
                        revCode = revCodePart[0];
                        revCodes.push(revCode);
                    }
                }
            }
        }

        const paymentRequest = {
            "booking_ids": bookingIDs,
            "client_id": $scope.client.id,
            "purchase_id": $scope.bb.total.id,
            "purchase_long_id": $scope.bb.total.long_id,
            "child_company": $scope.bb.company_id,
            "amounts": amounts,
            "host": $scope.bb.api_url,
            "descriptions": descriptions,
            "rev_codes": revCodes,
            "return_url": encodeURIComponent(`${$location.protocol()}://${$location.host()}:${$location.port()}/${$scope.bb.extra_setup.journey}_confirmation.html#/?purchase_id=${$scope.bb.total.id}&company_id=${$scope.bb.company_id}`)
        };

        // Make request to create payment basket
        $http({
            method: 'POST',
            // url: 'https://api.bookinglab.co.uk/payment/hey-centric',
            url: 'https://api.bookinglab.co.uk/payment/hey-centric',
            data: JSON.stringify(paymentRequest),
            headers: { 'Content-Type': 'application/json' }
        }).then(response => {
            var redirect = function (url) {
                window.location = url;
            };
            redirect(response.data.url);
            // Redirect to payment page
        }, err => {
            AlertService.danger({ msg: "Payment request failed" });
            console.log(err);
            loader.setLoaded();
        });

        // Retrieve payment id and company id

        // get the Revcode
        // console.log($scope.bb.current_item);
        // const longRevCode = $scope.bb.current_item.event.chain.extra.heycentric_rev_code;
        // let revCode = 'WBEVCALO';
        // if (longRevCode) {
        //     const revCodeParts = longRevCode.split('(');
        //     if (revCodeParts.length > 0) {
        //         const revCodePart = revCodeParts[revCodeParts.length - 1].split(')');
        //         revCode = revCodePart[0];
        //     }
        // }

        // let description = '';
        // if ($scope.bb.event_details) {
        //     description = $scope.bb.event_details.name;
        // } else {
        //     description = "Multi event booking";
        // }
    };
}



// WEBPACK FOOTER //
// ../src/public/javascripts/payment-redirect/payment_redirect.directive.js